import { DataAttributeDefinitions, provideDataClass } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfig } from '@/Data/pisaClient'

const followUpDataClassName = DataClassName.FOLLOW_UP
const followUpEndpoint = PisaDataClassEndpoint.FOLLOW_UP

export function pisaFollowUpActivityDataClass(
  attributes: DataAttributeDefinitions,
) {
  return provideDataClass(followUpDataClassName, {
    title: followUpDataClassName,
    restApi: createPisaRestApiConfig(followUpEndpoint),
    attributes,
  })
}
